import React, { useMemo } from "react";

import moment from "moment";

import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from "@material-ui/core";

import ExpandMoreIcon from "../../assets/svg/ExpandAccordionIcon.svg";
import { HH_MM, HH_MM_SS } from "../../../config/constants";
import { get_class_name_based_on_status } from "../utils/ApprovalRequestRecordUtils";
import { getDayFromSlot, isArrayValid, isAString, isEmptyOrNull } from "../../../utils/DataUtils";
import { generateElementIdentifier } from "utils/ApplicationUtils";
import { DATA_IDENTIFIER, ELEMENT } from "components/common/App/app-constant";

interface ApprovalRequestSlotDetailsForStandardInterface {
  classes: any;
  slot_day_data: any;
  slot_data_object?: any;
  slot_data_object_key: any;
}

const ApprovalRequestSlotDetailsForStandard = (props: ApprovalRequestSlotDetailsForStandardInterface) => {
  const { classes, slot_day_data, slot_data_object, slot_data_object_key } = props;

  const get_slot_time = (slot: any) => {
    if (!isEmptyOrNull(slot)) {
      if (!isEmptyOrNull(slot?.time)) {
        return slot.time;
      } else {
        const { startTime, endTime } = slot;
        if (!isEmptyOrNull(startTime) && !isEmptyOrNull(endTime)) {
          return `${moment(startTime).format(HH_MM)}-${moment(endTime).format(HH_MM)}`;
        }
      }
    }
    return "";
  };

  const get_buffer_time = (slot: any) => {
    if (!isEmptyOrNull(slot?.bufferTimeHours) && !isEmptyOrNull(slot?.bufferTimeMinutes)) {
      return parseInt(slot?.bufferTimeHours * 60 + slot?.bufferTimeMinutes);
    } else if (!isEmptyOrNull(slot?.bufferTime)) {
      return slot.bufferTime;
    }
    return "0";
  };

  const calculateOrderCutOff = (slot: any) => {
    const { bufferTime, startTime } = slot;
    let orderCutOff = moment(startTime, HH_MM_SS).subtract(bufferTime, "m").format("HH:mm");
    return orderCutOff || "";
  };

  const slotDay = useMemo(() => getDayFromSlot(slot_day_data), [slot_day_data]);

  const get_slot_details_view = (slot: any, slot_index: any) => {
    return (
      <Grid container spacing={1} key={`${slot_index}-slot_day_data-slot_index-slot_data_object`} className={get_class_name_based_on_status(slot, classes, slot_data_object_key)}>
        <Grid data-testid={generateElementIdentifier({key: DATA_IDENTIFIER.TIME, customKey: slot.id, element: ELEMENT.GRID})} item xs={3} className={classes.slotDetailsValueSpanStyle}>{`${get_slot_time(slot)}`}</Grid>
        <Grid data-testid={generateElementIdentifier({key: DATA_IDENTIFIER.CAPACITY, customKey: slot.id, element: ELEMENT.GRID})} item xs={3} className={classes.slotDetailsValueSpanStyle}>{`${slot.slotCapacity}`}</Grid>
        <Grid data-testid={generateElementIdentifier({key: DATA_IDENTIFIER.BUFFER_TIME, customKey: slot.id, element: ELEMENT.GRID})} item xs={3} className={classes.slotDetailsValueSpanStyle}>{`${get_buffer_time(slot)} mins`}</Grid>
        <Grid data-testid={generateElementIdentifier({key: DATA_IDENTIFIER.ORDER_CUT_OFF, customKey: slot.id, element: ELEMENT.GRID})} item xs={3} className={classes.slotDetailsValueSpanStyle}>{`${calculateOrderCutOff(slot)}`}</Grid>
      </Grid>
    );
  };

  const renderSlotData = () => {
    let slotsToRender;
    if (!isEmptyOrNull(slot_day_data) && !isEmptyOrNull(slot_data_object) && isArrayValid(slot_data_object?.[slot_day_data])) {
      slotsToRender = slot_data_object[slot_day_data];
    } else if (isArrayValid(slot_day_data?.generatedSlots)) {
      slotsToRender = slot_day_data.generatedSlots;
    }

    if (isArrayValid(slotsToRender)) {
      return slotsToRender.map((slot: any, slot_index: any) => get_slot_details_view(slot, slot_index));
    }
    return null;
  };

  return (
    <Accordion className={classes.slotsAccordion} defaultExpanded>
      <AccordionSummary expandIcon={<img src={ExpandMoreIcon} alt="Expand Accordion Icon" />} className={classes.slotsAccordionSummary}>
        <Typography 
          data-testid={
            generateElementIdentifier(
              {
                key: slotDay,
                customKey: slot_data_object_key === DATA_IDENTIFIER.SLOTS ? DATA_IDENTIFIER.SLOTS : DATA_IDENTIFIER.REQUESTED_SLOTS,
                element: ELEMENT.TYPOGRAPHY
              })} 
          className={classes.approverDetailsHeadingSpanStyle}>{`${slotDay}`}</Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.dBlock}>
        <Grid container spacing={1}>
          <Grid item xs={3} className={classes.approverDetailsHeadingSpanStyle}>{`Slot`}</Grid>
          <Grid item xs={3} className={classes.approverDetailsHeadingSpanStyle}>{`Capacity`}</Grid>
          <Grid item xs={3} className={classes.approverDetailsHeadingSpanStyle}>{`Buffer Time`}</Grid>
          <Grid item xs={3} className={classes.approverDetailsHeadingSpanStyle}>{`Order Cut-Off`}</Grid>
        </Grid>
        {renderSlotData()}
      </AccordionDetails>
    </Accordion>
  );
};

export default React.memo(ApprovalRequestSlotDetailsForStandard);
